class MatriculaUtils {
    
    constructor() {}
    
    /**
     * Agrupa las prematriculasAlumnos por alumno
     * 
     * @param {Object}
     * @returns Object
     */
    agruparAlumnos(prematricula) {
        
        let alumnosid = []
        let alumnos = []

        prematricula.alumnos.forEach(a => {
            
            let alumno = a.alumno
            let prematricula = {idioma: a.idioma, nivel: a.nivel, grupo: null}
            
            let exists = alumnosid.indexOf( alumno.id )
            
            if(exists == -1) {
    
                let alumno_group = {
                    id: alumno.id,
                    name: alumno.nombre,
                    dni: alumno.dni,
                    prematriculas: [prematricula]
                }

                alumnosid.push(alumno.id)
                alumnos.push(alumno_group)
    
            } else {
    
                let found = alumnos.find(current => current.id === alumno.id)
                
                if( typeof found !== 'undefined' ) {
                    let index = alumnos.indexOf(found)
                    alumnos[index].prematriculas.push(prematricula)
                }
            }
    
        })

        return alumnos
    }

}

export default MatriculaUtils;